import { render, staticRenderFns } from "./DashboardDoctor.vue?vue&type=template&id=a739e868&"
import script from "./DashboardDoctor.vue?vue&type=script&lang=js&"
export * from "./DashboardDoctor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports